import * as React from 'react';
import { sortBasedOnList } from '../utils';

export interface ITable5ClassProps {
  data: Table5Data;
}

export interface Table5Data { [key: string]: Table5Row }

export interface Table5Row {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

interface ITable5State {
}

const initialState: ITable5State = {
};

const sortOrder = [
  "Daylight",
  "Dawn / Dusk",
  "Dark-Lighted",
  "Dark-Not Lighted",
  "Dark-Unk. Lighting",
  "Other",
  "Unknown",
  "Not Stated",
  "TOTALS",
];

export default class Table5 extends React.Component<ITable5ClassProps, ITable5State> {
  public constructor(props: any) {
    super(props);
    this.state = initialState;
  };

  public render() {
    return (
      <React.Fragment>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1">
            <thead>
              <tr>
                <th rowSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">5</span>
                    <span className="header-text">LIGHT CONDITION</span>
                  </div>
                </th>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3}>INJURY</th>
                <th rowSpan={2}>PDO **</th>
              </tr>
              <tr>
                <th>A*</th>
                <th>B*</th>
                <th>C*</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].total}</td>
                  <td className="numberTotals">{this.props.data[key].fatal}</td>
                  <td className="numberTotals">{this.props.data[key].injuryA}</td>
                  <td className="numberTotals">{this.props.data[key].injuryB}</td>
                  <td className="numberTotals">{this.props.data[key].injuryC}</td>
                  <td className="numberTotals">{this.props.data[key].pdo}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </React.Fragment>
    );
  }
}
